<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <div class="overflow-x-auto style-scrollbar">
        <div
          class="relative pb-4"
          :class="data.size?.value === 'base' ? 'max-w-container-text' : 'max-w-container-max'"
        >
          <table class="w-full">
            <caption class="w-full">
              <h2 class="mb-4 text-left text-body-2xl">
                {{ data.title }}
              </h2>
            </caption>
            <tbody v-animate-children-in-from-left>
              <tr
                v-for="(row, index) in data.table"
                :key="index"
                class="border-y border-y-dark [&_th]:bg-grey-100 hover:bg-theme-100"
              >
                <Component
                  :is="isHighlighted(index) ? 'th' : 'td'"
                  v-for="(cell, i) in row.cells"
                  :key="i"
                  class="
                    py-2 pr-2 text-left text-body-lg
                    first-of-type:w-max first-of-type:min-w-26 first-of-type:max-w-md first-of-type:pl-2
                    first-of-type:pr-10
                    lg:text-body-xl lg:first-of-type:min-w-72
                  "
                >
                  {{ cell }}
                </Component>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsBrBrTableFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsBrBrTableFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)

function isHighlighted(index: number) {
  return props.data.select_field?.some(function (el) {
    return Number(el?.value) === index + 1
  })
}
</script>
